module.exports = __webpack_public_path__ + "img/04_Considerate Carer.c83e5f52.svg";